import template from './min-lease-term.jade';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.minLeaseTerm', [])
    .directive('cianAfPriceAndDealTermsMinLeaseTerm', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.limitMin = 0;
            this.limitMax = 1e3;

            this.validation = validation(this.form, 'bargainTerms.minLeaseTerm', {
                parse: 'Введите число',
                min: `Срок должен быть больше 0`,
                max: 'Не более 3 символов',
            });
        },
        controllerAs: 'minLeaseTerm',
        template,
    }))
    .name;
